import Table from 'components/common/Table'
import React from 'react'

const SEARCH_OPTIONS = ['translatorFullName', 'translatorEmail']
const ORDER_OPTIONS = ['translatorFullName', 'translatorEmail', 'createdAt']

const Calls = ({ title, endpoint }) => {
  return (
    <Table
      key={endpoint}
      title={title}
      endpoint={endpoint}
      paginated
      dataAccessor='calls'
      searchOptions={SEARCH_OPTIONS}
      orderOptions={ORDER_OPTIONS}
    />
  )
}

export default Calls
